/**
 * The editors' settings: a gear at the end of the view widget's top row that
 * opens a small card of per-machine preferences (see preferences/): the
 * measurement units, and whether moved things snap: rooms to neighboring
 * walls and openings in the assembler, elements to nearby edges in the room
 * editor. Its rows are core's `SETTINGS_MENU`.
 */

import { SETTINGS_MENU } from '@kaiizen/kai-floor-plan-editor-core';
import { FloorPlanMenuCard } from './FloorPlanMenuCard';

export const SettingsMenu = (): React.JSX.Element => <FloorPlanMenuCard menu={SETTINGS_MENU} testId='settings-button' />;
